import { type FC, type ReactNode } from 'react';
import AnalyticsContext, { type AnalyticsContextProps } from './AnalyticsContext';

interface AnalyticsProviderProps {
  children?: ReactNode;
  analyticsContext: AnalyticsContextProps;
}

const AnalyticsProvider: FC<AnalyticsProviderProps> = ({ children, analyticsContext }) => (
  <AnalyticsContext.Provider value={analyticsContext}>{children}</AnalyticsContext.Provider>
);

export default AnalyticsProvider;
